import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OtpAuthService } from './otp-auth.service';

@Injectable({ providedIn: 'root' })
export class OtpGuard implements CanActivate {

	constructor(private otpAuth: OtpAuthService, private router: Router) { }

	canActivate(): boolean {
		if (this.otpAuth.isValidated()) {
			return true; // allow access
		} else {
			this.router.navigate(['/secfile', 'null']); // redirect to OTP page
			return false;
		}
	}
}